import * as React from 'react'
import cx from 'classnames'
import SearchField from 'components/SearchField'
import { EMPTY, Observable } from 'rxjs'
import styles from './ModalSheetSearchHeader.sass'
import {
  ModalSheetContext,
  ModalSheetHeaderCloseButton,
  ModalSheetHeaderProps,
  ModalSheetHeaderShell,
} from '.'

export interface ModalSheetSearchHeaderProps extends ModalSheetHeaderProps {
  value: string
  onChange: (newValue: string) => unknown
  placeholder?: string
  focus$?: Observable<unknown>
  onKeyDown?: React.KeyboardEventHandler
  ['data-test']?: string
}

/**
 * Modal sheet header with a search bar.
 */
export const ModalSheetSearchHeader = React.forwardRef(
  function ModalSheetSearchHeader(
    {
      value,
      onChange,
      placeholder,
      focus$ = EMPTY,
      lonelyChild,
      bordered,
      withCloseButton,
      'data-test': dataTest,
      ...rest
    }: ModalSheetSearchHeaderProps,
    ref: React.Ref<HTMLInputElement>,
  ) {
    const { close } = React.useContext(ModalSheetContext)
    const canClose = withCloseButton && !value

    return (
      <ModalSheetHeaderShell
        size="sm"
        lonelyChild={lonelyChild}
        bordered={bordered}
      >
        <div className={cx(styles.root, !canClose && styles.full)}>
          <div className={styles.field}>
            <SearchField
              autoFocus
              stretch
              dataTest={dataTest}
              focus$={focus$}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              ref={ref}
              {...rest}
            />
          </div>

          <div className={cx(styles.closeBtn, canClose && styles.closeVisible)}>
            <ModalSheetHeaderCloseButton
              onClick={canClose ? close : undefined}
            />
          </div>
        </div>
      </ModalSheetHeaderShell>
    )
  },
)
